import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import RightDrawerDesktop from "../../../../components/WMS/Desktop/RightDrawerDesktop";
import SearchBar from "../../../../components/List/components/SearchBar";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {FormGroup, Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {greyishBlue500} from "../../../../assets/jss/main";

DesktopProviderDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    providers: PropTypes.array.isRequired,
    handleSelectProvider: PropTypes.func.isRequired,
    isModel: PropTypes.bool.isRequired
};

const thumbnailStyle = {
    width: "40px",
    height: "40px",
    margin: "auto 0",
    borderRadius: "8px"
}

const titleStyle = {
    height: "fit-content",
    margin:"auto 0",
    fontSize: "14px",
    fontWeight: 600
}

const subtitleStyle = {
    height: "fit-content",
    margin:"auto 0",
    fontSize: "12px",
    fontWeight: 400,
    color: greyishBlue500
}

function DesktopProviderDrawer({open, handleClose, providers, handleSelectProvider, isModel}) {
    const [searchString, setSearchString] = useState("")
    const [formattedProviders, setFormattedProviders] = useState([])
    const [searchedProviders, setSearchedProviders] = useState([]) // --> Use this to update the displayed list


    useEffect(() => {
        if (searchString.length === 0) {
            setSearchedProviders(formattedProviders)
        } else {
            let tempData = []
            formattedProviders.map(provider => {
                if (provider.name.toLowerCase().includes(searchString.toLowerCase())) {
                    tempData.push(provider)
                }
            })
            setSearchedProviders(tempData)
        }
    }, [formattedProviders, searchString]);


    useEffect(() => {
        const dataKeys = Object.keys(providers)
        let tempData = []
        dataKeys.map((k) => {
            if (k !== "all") {
                tempData.push(providers[k])
            }
        })

        setFormattedProviders(tempData)
    }, [providers]);
    return (
        <RightDrawerDesktop
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.newPickingMission.providerDrawer.title"}/>}
            subtitle={<FormattedMessage id={"wms.newPickingMission.providerDrawer.subtitle"}/>}
            underTitle={
                <SearchBar
                    customPlaceholder={"wms.newPickingMission.providerDrawer.searchBarPlaceholder"}
                    onChange={(value) => setSearchString(value)}
                    style={{marginBottom: "24px"}}
                />
            }
        >
            <FormGroup sx={{marginTop: "20px"}}>
                {providers && searchedProviders && searchedProviders.map((provider) => {
                    if (!isModel && provider.count === 0) {
                        return null
                    }
                    return (
                        <div onClick={() => handleSelectProvider(provider)} style={{marginBottom: "24px"}}>
                            <Grid container direction={'row'} flexWrap={'nowrap'}>
                                <Grid container gap={"8px"} direction={"row"} flexWrap={'nowrap'}>
                                    {provider.logo && (<img style={thumbnailStyle} src={provider.logo} alt={`${provider.name} icon`}/>)}
                                    <Grid container direction={"column"}>
                                        <span style={titleStyle}>{provider.name}</span>
                                        <span style={subtitleStyle}>{provider.count} <FormattedMessage id={"wms.newPickingMission.providerDrawer.articles"}/></span>
                                    </Grid>
                                </Grid>

                                <Checkbox checked={provider.selected}/>
                            </Grid>
                        </div>
                    )
                })}
            </FormGroup>

        </RightDrawerDesktop>
    );
}

export default DesktopProviderDrawer;